import { createContext, useContext } from "react";

const SearchBarContext = createContext();

export function useSearchBar() {
  return useContext(SearchBarContext);
}

export default SearchBarContext;
